import { z } from "zod";

// Глобальные настройки: экономика, рассылки, пул вариантов. Хранятся построчно
// в таблице settings, читаются этой схемой — значения по умолчанию здесь же.

export const appSettingsSchema = z.object({
  livesMax: z.number().int().min(1).max(99).default(5),
  livesRegenMinutes: z.number().int().min(1).max(1440).default(30),
  /** Сколько жизней даёт приглашённый друг, дошедший до зачёта */
  livesPerReferral: z.number().int().min(0).max(99).default(5),

  hintsDailyFree: z.number().int().min(0).max(99).default(3),
  hintsPerReferral: z.number().int().min(0).max(99).default(2),

  pointsPerReferral: z.number().int().min(0).default(50),
  /** За сколько приглашённых открывается следующий уровень досрочно */
  unlockPerInvites: z.number().int().min(0).max(99).default(3),
  /** Приглашённый считается «своим», когда прошёл столько уровней */
  referralQualifyLevels: z.number().int().min(1).max(10).default(1),

  /** Сколько свободных вариантов держать в пуле на каждый уровень */
  variantPoolMin: z.number().int().min(1).max(500).default(50),

  broadcastRatePerSecond: z.number().int().min(1).max(30).default(25),
  quietHoursStart: z.number().int().min(0).max(23).default(22),
  quietHoursEnd: z.number().int().min(0).max(23).default(9),
  quietHoursEnabled: z.boolean().default(true),

  /** Показывать ли лидерборд игрокам */
  leaderboardEnabled: z.boolean().default(true),
  supportUrl: z.string().default(""),
});

export type AppSettings = z.infer<typeof appSettingsSchema>;

export const defaultAppSettings: AppSettings = appSettingsSchema.parse({});

export const APP_SETTINGS_FIELDS: {
  key: keyof AppSettings;
  label: string;
  group: string;
  hint?: string;
}[] = [
  { key: "livesMax", label: "Максимум жизней", group: "Жизни" },
  { key: "livesRegenMinutes", label: "Минут на восстановление жизни", group: "Жизни" },
  { key: "livesPerReferral", label: "Жизней за приглашённого", group: "Жизни" },
  { key: "hintsDailyFree", label: "Бесплатных подсказок в сутки", group: "Подсказки" },
  { key: "hintsPerReferral", label: "Подсказок за приглашённого", group: "Подсказки" },
  { key: "pointsPerReferral", label: "Очков за приглашённого", group: "Рефералы" },
  {
    key: "unlockPerInvites",
    label: "Приглашённых на досрочное открытие уровня",
    group: "Рефералы",
    hint: "0 — не открывать уровни за приглашения",
  },
  { key: "referralQualifyLevels", label: "Уровней до зачёта приглашённого", group: "Рефералы" },
  { key: "variantPoolMin", label: "Вариантов в пуле на уровень", group: "Уровни" },
  { key: "broadcastRatePerSecond", label: "Сообщений в секунду", group: "Рассылки" },
  { key: "quietHoursEnabled", label: "Соблюдать окно тишины", group: "Рассылки" },
  { key: "quietHoursStart", label: "Тишина с, час", group: "Рассылки" },
  { key: "quietHoursEnd", label: "Тишина до, час", group: "Рассылки" },
  { key: "leaderboardEnabled", label: "Показывать лидерборд", group: "Игра" },
  { key: "supportUrl", label: "Ссылка поддержки", group: "Игра" },
];
